import ioQuery = require("dojo/io-query");
import { UPDATE_ITEMS, FILTER_ITEMS, HASH_CHANGE, SAVE_APP_BASE_RESULT } from "../_actions";

export interface ItemsState {
    allowedItemTypes: { [type: string]: boolean };
    allItems: __Component.Pojo[];
    appId: string;
    filteredItems: __Component.Pojo[];
    displayKey: string;
    viewerItem: __Component.Pojo;
} 

const initialState: ItemsState = {
    allowedItemTypes: {},
    allItems: [],
    appId: "",
    filteredItems: [],
    displayKey: "",
    viewerItem: {}
};

const allItemTypes: String[] = [
    "Web Map",
    "CityEngine Web Scene",
    "Web Scene",
    "360 VR Experience",
    "Pro Map",
    "Feature Service",
    "Map Service",
    "Image Service",
    "KML",
    "KML Collection",
    "WFS",
    "WMTS",
    "Feature Collection",
    "Feature Collection Template",
    "OGCFeatureServer",
    "Vector Tile Service",
    "Scene Service",
    "Relational Database Connection",
    "Web Mapping Application",
    "Mobile Application",
    "Operations Dashboard Add In",
    "Native Application",
    "Native Application Template",
    "Native Application Installer",
    "Workforce Project",
    "Form",
    "Insights Workbook",
    "Insights Model",
    "Insights Page",
    "Dashboard",
    "Hub Initiative",
    "Hub Site Application",
    "Hub Page",
    "AppBuilder Widget Package",
    "Symbol Set",
    "Color Set",
    "Shapefile",
    "File Geodatabase",
    "CSV",
    "CAD Drawing",
    "Service Definition",
    "Microsoft Word",
    "Microsoft Powerpoint",
    "Microsoft Excel",
    "PDF",
    "Image",
    "Visio Document",
    "iWork Keynote",
    "iWork Pages",
    "iWork Numbers",
    "Report Template",
    "Statistical Data Collection",
    "Map Document",
    "Map Package",
    "Mobile Basemap Package",
    "Mobile Map Package",
    "Tile Package",
    "Vector Tile Package",
    "Project Package",
    "Task File",
    "ArcPad Package",
    "Explorer Map",
    "Globe Document",
    "Scene Document",
    "Published Map",
    "Map Template",
    "Windows Mobile Package",
    "Pro Map",
    "Layout",
    "Project Template",
    "Layer",
    "Layer Package",
    "Explorer Layer",
    "Scene Package",
    "Image Collection",
    "Desktop Style",
    "Geoprocessing Package",
    "Geoprocessing Package (Pro version)",
    "Geoprocessing Sample",
    "Locator Package",
    "Rule Package",
    "Raster function template",
    "Deep Learning Package",
    "ArcGIS Pro Configuration",
    "Workflow Manager Package",
    "Desktop Application",
    "Desktop Application Template",
    "Code Sample",
    "Desktop Add In",
    "Explorer Add In",
    "ArcGIS Pro Add In",
    "Geometry Service",
    "Geocoding Service",
    "Network Analysis Service",
    "Geoprocessing Service",
    "Workflow Manager Service",
    "Big Data File Share",
    "Web Tool",
    "Notebook",
    "Web Experience",
    "Web Experience Template",
    "Feed",
    "StoryMap", 
    "Document Link", 
    "Application"
  ];

export default (state: ItemsState = initialState, action: { type: string, payload: any }): ItemsState => {
    switch (action.type) {
        case SAVE_APP_BASE_RESULT:
            const itemTypes = !!action.payload.config.itemTypes && action.payload.config.itemTypes.length > 0 ?
                action.payload.config.itemTypes :
                allItemTypes.toString();
            return {
                ...state,
                allowedItemTypes: itemTypes.split(",")
                    .map((type: string) => type.trim())
                    .reduce((r: ItemsState["allowedItemTypes"], c: string) => {
                        r[c] = true;
                        return r;
                    }, {}),
                appId: action.payload.config.appid
            };
        case UPDATE_ITEMS:
            return {
                ...state,
                allItems: action.payload.filter((item: any) => item.id !== state.appId)
            };
        case HASH_CHANGE:
            const hashParams = ioQuery.queryToObject(action.payload);
            if (hashParams.viewer) {
                const viewerItem = state.allItems.filter((item) => item.id === hashParams.viewer)[0];
                return {
                    ...state,
                    viewerItem: viewerItem ? viewerItem : {},
                    filteredItems: filterItems(
                        state.allItems,
                        hashParams.query ? hashParams.query.toLowerCase() : "",
                        state.allowedItemTypes
                    ),
                    displayKey: Math.random().toString(36).substring(7)
                };
            }
            return {
                ...state,
                filteredItems: filterItems(
                    state.allItems,
                    hashParams.query ? hashParams.query.toLowerCase() : "",
                    state.allowedItemTypes
                ),
                displayKey: Math.random().toString(36).substring(7)
            };
        default:
            return state;
    }
};

function filterItems(items: __Component.Pojo[], filter: string, allowedItemTypes: ItemsState["allowedItemTypes"]) {
    return items.filter((item: __Component.Pojo) => (
        allowedItemTypes[item.type] && (
            item.title.toLowerCase().indexOf(filter) !== -1 ||
            item.type.toLowerCase().indexOf(filter) !== -1 ||
            item.owner.toLowerCase().indexOf(filter) !== -1 ||
            (item.tags && item.tags.map((tag: string) => tag.toLowerCase()).indexOf(filter.toLowerCase()) !== -1) ||
            (item.description && item.description.indexOf(filter) !== -1) ||
            (item.snippet && item.snippet.indexOf(filter) !== -1)
        ) && (
            (item.type && item.type !== "StoryMap") ||
            (item.type && item.typeKeywords && item.type === "StoryMap" && item.typeKeywords.indexOf("smstatusdraft") === -1) 
        )
    ));
}



// WEBPACK FOOTER //
// ./src/mainApp/MinimalGallery/_reducers/items.ts